api = require '../api'

module.exports =

    fetch: ->
        api.send
          method: 'GET'
          path: "/api/v2/tenants?id=" + TENANT
